import React, { Component } from 'react';
import BaseVisualization from '@splunk/dashboard-visualizations/common/BaseVisualization';
import { withVisualizationHOCs } from '@splunk/dashboard-visualizations/utils/enhancer';
import getTheme from '@splunk/themes/getTheme';
import pick from '@splunk/themes/pick';
import variables from '@splunk/themes/variables';
import { enableClickHandler, getClickHandler } from '@splunk/dashboard-visualizations/utils/eventUtils';
import ReactSingleValueRadial from '@splunk/react-visualizations/SingleValueRadial';
import { parse, dataContract } from '@splunk/visualization-encoding-parsers/SingleValueRadialParser';
import { SingleValueRadial as SingleValueRadialIcon } from '@splunk/visualization-icons';
import IconPlaceholder from '@splunk/dashboard-visualizations/common/IconPlaceholder';
import { isColor } from '@splunk/visualizations-shared/colorUtils';
import optionsSchema from './optionsSchema';
import editor from './editorConfig';
import { INITIAL_WIDTH, INITIAL_HEIGHT } from '../SingleValue';

export class SingleValueRadialComponent extends Component {
    static propTypes = {
        ...BaseVisualization.propTypes,
    };

    static defaultProps = {
        ...BaseVisualization.defaultProps,
        height: INITIAL_HEIGHT,
    };

    static dataContract = dataContract;

    static vizContract = {
        initialDimension: {
            width: INITIAL_WIDTH,
            height: INITIAL_HEIGHT,
        },
    };

    static schema = optionsSchema;

    static editor = editor;

    render() {
        const {
            dataSources,
            options,
            encoding,
            width,
            height,
            style,
            onEventTrigger,
            mode,
            hasEventHandlers,
            onComputedProps,
            theme,
        } = this.props;
        const { value, deltaValue, backgroundColor: encodingBackgroundColor } = parse(dataSources, encoding);

        const themeVariables = theme?.splunkThemeV1 ? getTheme(theme?.splunkThemeV1) : {};
        const showTrendIndicator = !Number.isNaN(Number(deltaValue)) && options.showTrendIndicator !== false;
        const backgroundColor =
            (isColor(encodingBackgroundColor) && encodingBackgroundColor) ||
            (isColor(options.backgroundColor) && options.backgroundColor) ||
            themeVariables?.backgroundColorSidebar ||
            null;
        // Click handler
        const onValueClick = enableClickHandler(hasEventHandlers, mode)
            ? getClickHandler(onEventTrigger, { value, deltaValue })
            : null;

        onComputedProps(backgroundColor ? { backgroundColor } : {});
        return (
            <ReactSingleValueRadial
                width={width}
                height={height}
                style={style}
                // viz props from options (options < encoding)
                {...options}
                // viz props from encoding
                value={value}
                deltaValue={deltaValue}
                // viz props based on options and encoding
                backgroundColor={backgroundColor}
                showTrendIndicator={showTrendIndicator}
                // event handler
                onValueClick={onValueClick}
            />
        );
    }
}

export default withVisualizationHOCs({
    enableBackgroundColorOption: true,
    // hack to add a themed SVR placeholder background color (which does not obtain theming information from PlatformViz)
    // globally wrapping `withTheme` results in inadvertent changes to radial graph coloring, so we add this to limit the color change to the placeholder background
    defaultBackgroundColor: pick({
        enterprise: {
            dark: variables.black,
            light: variables.backgroundColor,
        },
        prisma: variables.backgroundColorSidebar,
    }),
    placeholder: <IconPlaceholder icon={<SingleValueRadialIcon />} />,
})(SingleValueRadialComponent);
